// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductRaisinPanel_content__GwNtb","image":"ProductRaisinPanel_image__Bwd6H"};